module.exports = __webpack_public_path__ + "static/media/pinterest_rc.fe39bbd6.svg";